import { useState } from "react";
import { Link, Button, Input } from "components/core";
import { Row, Col } from "react-flexbox-grid";
import Switch from "@material-ui/core/Switch";
import { useGlobalContext } from "context/GlobalContext";
import { fetchBackend } from "helpers";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SchemaSignIn = yup.object().shape({
  email: yup
    .string()
    .email("El correo ingreso no es valido")
    .required("Ingrese su correo para continuar"),
  password: yup.string().required("Ingrese una contraseña"),
});

const SchemaSignUp = yup.object().shape({
  name: yup.string().required("Ingrese su nombre para continuar"),
  email: yup
    .string()
    .email("El correo ingreso no es valido")
    .required("Ingrese su correo para continuar"),
  password: yup
    .string()
    .required("Ingrese una contraseña")
    .min(6, "Se requiere minimo 6 caracteres para continuar"),
});

export const FormSignUp = ({
  isLogin,
  currentPhone,
  sendStepLogin,
  sendStepRegister,
}) => {
  const [isLoading, setLoading] = useState(false);
  const gContext = useGlobalContext();

  const { handleSubmit, register, control, errors } = useForm({
    resolver: yupResolver(isLogin ? SchemaSignIn : SchemaSignUp),
  });

  const addUser = async (obj) => {
    const { error, response } = await fetchBackend({
      method: "post",
      url: "user",
      data: obj,
    });

    if (!error) {
      setLoading(false);
      gContext.toggleAlert({ message: "Usuario registrado con exito" });
      gContext.handleSetUser(response.data.result);
    } else {
      setLoading(false);

      let msg;
      switch (
        (response.data?.error || "").trim().toLowerCase().split(" ").join("-")
      ) {
        case "user-not-found":
          msg = "Este correo no se encuentra registrado en el sistema";
          break;
        case "password-not-valid":
          msg = "Contraseña erronea para esta cuenta";
          break;
        case "numero-duplicado":
          msg = "Error número duplicado";
          break;
        case "email-duplicado":
          msg = "Error correo duplicado";
          break;
        default:
          msg =
            "Hubo un error al intentar registrar el usuario, revisa la información";
          break;
      }

      gContext.toggleAlert({
        message: msg,
        type: "error",
      });
    }
  };

  const signIn = async (form) => {
    const { error, response } = await fetchBackend({
      url: "user/login",
      method: "post",
      data: form,
    });

    if (!error) {
      setLoading(false);
      if (response.data.user?.type === "CLIENT") {
        gContext.toggleAlert({
          message: `Bienvenido de nuevo ${response.data.user?.name || ""}`,
        });
        gContext.handleSetUser(response.data.user);
      } else {
        gContext.toggleAlert({
          message: "Esta no es una cuenta de usuario",
          type: "error",
        });
      }
    } else {
      setLoading(false);
      // .trim().toLowerCase().split(" ").join("-")
      let msg;
      switch (response.data.error) {
        case "user-not-found":
          msg = "Este correo no se encuentra registrado en el sistema";
          break;
        case "password-not-valid":
          msg = "Contraseña erronea para esta cuenta";
          break;
        // case "numero-duplicado":
        //   msg = "Error número duplicado";
        //   break;
        // case "email-duplicado":
        //   msg = "Error correo duplicado";
        //   break;
        default:
          msg = response.data.error;
          // msg = "Hubo un error al intentar iniciar sesión";
          break;
      }

      gContext.toggleAlert({
        message: msg,
        type: "error",
      });
    }
  };

  const onSubmit = (data) => {
    setLoading(true);

    if (isLogin) {
      signIn(data);
    } else {
      addUser({
        ...data,
        phoneNumber: currentPhone,
        type: "CLIENT",
        dateCreated: new Date(),
      });
    }
  };

  const textBtn = isLogin ? "Ingresar" : "Registrar";

  return (
    <Row>
      <Col xs={12}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row className="ph2">
            {!isLogin && (
              <Input
                name="name"
                placeholder="Nombre"
                ref={register}
                disabled={isLoading}
                error={errors.name?.message}
              />
            )}
            <Input
              name="email"
              placeholder="Correo"
              ref={register}
              disabled={isLoading}
              error={errors.email?.message}
            />
            <Input
              name="password"
              placeholder="Contraseña"
              type="password"
              ref={register}
              disabled={isLoading}
              error={errors.password?.message}
            />
            <Col md={12}>
              <Row className="ph3">
                <Col md={isLogin ? 6 : 12}>
                  <Row middle="xs">
                    <label>Recordarme</label>
                    <Controller
                      name="remember"
                      control={control}
                      defaultValue={false}
                      render={(props) => (
                        <Switch
                          disabled={isLoading}
                          onChange={(e) => props.onChange(e.target.checked)}
                          checked={props.value}
                        />
                      )} // props contains: onChange, onBlur and value
                    />
                  </Row>
                </Col>
                {isLogin && (
                  <Col md={6}>
                    <Row middle="xs" end="xs" className="h-100">
                      <Link
                        isNotLink
                        to="/recuperar-acceso"
                        className="text-center f7"
                      >
                        Olvide mi contraseña
                      </Link>
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>

            <Col md={12} className="mt2">
              <Button
                htmlType="submit"
                color="primary"
                size="large"
                className="w-100"
                loading={isLoading}
              >
                {textBtn}
              </Button>
            </Col>
          </Row>

          <Row center="xs">
            <Col md={12} className="mt2">
              {isLogin ? "No tengo cuenta" : "Ya tengo una cuenta"}
              &nbsp;
              <Link
                isNotLink
                to={null}
                className="text-center"
                onClick={isLogin ? sendStepRegister : sendStepLogin}
              >
                {isLogin ? "Crear cuenta nueva" : "Iniciar sesión"}
              </Link>
            </Col>
          </Row>

          <Row center="xs">
            <Col md={12} className="mt3 f7">
              Al registrarse esta aceptando nuestros
              <br />
              <Link
                isNotLink
                to={null}
                className="text-center"
                onClick={gContext.toggleLegalModal}
              >
                Términos y Condiciones.
              </Link>
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
};
